/** Folding a `PATCH /api/me` reply back into the account document.
 *
 * The handler answers `{ user }` and nothing else — the statistics beside it
 * are a page of counting that a rename does not change, so it does not do
 * that counting twice. But two of those statistics are not counts: `stats.
 * live_public` is the same column as `user.live_public`, and `spectate_url`
 * is only shown when it is true. A screen that writes the reply into
 * `account.user` and leaves `account.stats` where it was therefore ends up
 * with a card that says "private" about a stream the same screen has just
 * made public, which reads as a save that did not happen.
 *
 * Hence one function rather than a spread at each call site: the two fields
 * that mirror each other are brought across together, and the counts — which
 * the reply genuinely does not carry — are left alone.
 */

import type { Account, User } from '@/lib/types';

export function withUser(account: Account, user: User): Account {
  return {
    ...account,
    user,
    stats: { ...account.stats, live_public: user.live_public },
  };
}
